import { render, staticRenderFns } from "./ConfigInputs.vue?vue&type=template&id=3b8a2f0d&scoped=true"
import script from "./ConfigInputs.vue?vue&type=script&lang=js"
export * from "./ConfigInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8a2f0d",
  null
  
)

export default component.exports